import { Component, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

import { AppService } from '@app/app.service';

@Component({
  selector: 'app-support-form-dialog',
  standalone: true,
  templateUrl: './support-form-dialog.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule
  ],
})
export class SupportFormDialogComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<SupportFormDialogComponent>);
  private appService = inject(AppService);

  form = this.fb.group({
    type: ['bug', Validators.required],
    subject: ['', Validators.required],
    message: ['', Validators.required],
  });

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.appService.errorSnackBar('Fill in all required fields!');
      return;
    }

    this.appService.post('user/support', this.form.value).subscribe({
      next: (res) => {
        this.appService.successSnackBar(res.message);
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.appService.errorSnackBar(err.error.message);
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}